/**
 * created by panjm on 2019-10-24
 *
 * description： 审批处理相关接口地址配置
 *
 */

const config = require('libs/config.js');

const handle = {
	// 表格数据接口地址
	getList: config.MS_SP_PATH + '/v1/operate/audit/list',
	// 查看/审批弹窗详情获取接口地址
	getAuditDetail: config.MS_SP_PATH + '/v1/operate/audit/new/schedule',
	// 同意
	agree: checkDataId => config.MS_SP_PATH + `/v1/operate/audit/${checkDataId}`,
	// 驳回
	refuse: checkDataId => config.MS_SP_PATH + `/v1/operate/audit/${checkDataId}`,
	// 待审核数量
	count: config.MS_SP_PATH + '/v1/operate/audit/count',
	// 已读
	read: config.MS_SP_PATH + '/v1/operate/batch/read',
	// 批量审核
	batch: config.MS_SP_PATH + '/v1/operate/batch/audit'
};

export default handle;



// WEBPACK FOOTER //
// ./src/api/handle/index.js